import { find } from 'lodash'

export default function isLicensed(assessmentSetId, userLicenses, user) {
    if (user && user.role === 'Super Administrator') return true
    let val = find(userLicenses, function (val) {
        return val.licenseSet === assessmentSetId
    })
    if (val) return true;
    return false;
}




// WEBPACK FOOTER //
// ./src/helpers/users/licenses/isLicensed.js